import PropTypes from 'prop-types';

export default PropTypes.shape({
  instanceid: PropTypes.string,
  contributedby: PropTypes.string,
  usedby: PropTypes.strong,
  available: PropTypes.bool,
  deleted: PropTypes.bool,
});
